// ----------------------------------------------------------------------
// <copyright file="Izenda.SaveWorkspacePopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Save Workspace component
 */
!(function() {
  var compute = require('mobx').expr;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.CopyManagementConstants');

  var EventUtils = require('EventUtils');
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var uiState = require('logic/Izenda.UiState');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
  var ValidateDropDown = Validator()(require('share/components/controls/Izenda.DropDown'));
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var actions = require('./Izenda.SaveWorkspacePopupAction');
  const { isEmpty } = require('lodash/fp');
  var SaveWorkspacePopup = React.createClass({
    componentWillMount: function() {
      var props = this.props;
      var store = props.store;
      // Set default ownerId is user log in
      var ownerList = store.masterStore.ownerList;
      if (!isEmpty(ownerList)) {
        store.item.ownerId = uiState.currentUser.id;
      }
    },

    render: function() {
      var props = this.props;
      var localization = props.localization;

      return (
        <Popup visible type="none" onClosing={props.onClosing} autoClose={false}>
          <Popup.Header
            title={
              props.store.item.isNew
                ? localization.getText('COMMON_LABEL_SAVE')
                : localization.getText('COMMON_LABEL_SAVE_AS')
            }
          />
          <Popup.Body>
            <div className="izenda-SaveWorkspacePopup">
              <GridLayout>
                <GridLayout.Row>
                  <GridLayout.Col cols={2}>
                    <label className="validation required">{localization.getText('COMMON_LABEL_NAME')}</label>
                  </GridLayout.Col>
                  <GridLayout.Col cols={10}>
                    <ValidateInput
                      type="text-box"
                      className="form-control"
                      value={props.workspaceName}
                      validations={constants.SAVE_WORKSPACE_CONSTRAINTS.NAME}
                      onChange={EventUtils.notifyChange(props.setWorkspaceName, EventUtils.INPUT)}
                      field="Name"
                    />
                  </GridLayout.Col>
                </GridLayout.Row>

                <GridLayout.Row>
                  <GridLayout.Col cols={2}>
                    <label className="validation required">{localization.getText('COMMON_LABEL_OWNER')}</label>
                  </GridLayout.Col>
                  <GridLayout.Col cols={10}>
                    <ValidateDropDown
                      className="u_fullWidth"
                      options={props.store.masterStore.ownerList}
                      onChange={EventUtils.notifyChange(props.onChangeOwner.bind(props), EventUtils.DROPDOWN)}
                      value={props.store.item.ownerId}
                      valueField="id"
                      labelField="fullName"
                      validations={constants.SAVE_WORKSPACE_CONSTRAINTS.OWNER}
                      field="ownerList"
                    />
                  </GridLayout.Col>
                </GridLayout.Row>

                <GridLayout.Row>
                  <GridLayout.Col cols={2}>
                    <label>{localization.getText('COMMON_LABEL_DESCRIPTION')}</label>
                  </GridLayout.Col>
                  <GridLayout.Col cols={10}>
                    <textarea
                      className="form-control izenda-Description"
                      onChange={EventUtils.notifyChange(props.updateWorkspaceDescription.bind(props), EventUtils.INPUT)}
                      value={props.store.item.description}
                    />
                  </GridLayout.Col>
                </GridLayout.Row>
              </GridLayout>
            </div>
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type="accept">
              {localization.getText('COMMON_LABEL_SAVE')}
            </Popup.ConfirmationButton>
            <Popup.ConfirmationButton type="cancel">
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect(actions)(SaveWorkspacePopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/ActionBar/Izenda.SaveWorkspacePopup.jsx